import React, { useState } from 'react';
import { ModalBase } from './ModalBase';

interface CadastroClienteForm {
  name: string;
  email: string;
  phone: string;
  password: string;
}

export function CadastroClienteModal() {
  const [form, setForm] = useState<CadastroClienteForm>({
    name: '',
    email: '',
    phone: '',
    password: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (field: keyof CadastroClienteForm) => (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = () => {
    setSubmitted(true);
  };

  return (
    <ModalBase>
      <h3 className="modal-box__title">Criar conta</h3>
      <p className="modal-box__subtitle">Assine em menos de 2 minutos</p>

      <label className="modal-form__label">
        Nome completo <span className="modal-form__label-required">*</span>
      </label>
      <input
        type="text"
        placeholder="Seu nome"
        value={form.name}
        onChange={handleChange('name')}
        className="modal-form__input"
      />

      <label className="modal-form__label">
        E-mail <span className="modal-form__label-required">*</span>
      </label>
      <input
        type="email"
        placeholder="seu@email.com"
        value={form.email}
        onChange={handleChange('email')}
        className="modal-form__input"
      />

      <label className="modal-form__label">
        Celular <span className="modal-form__label-required">*</span>
      </label>
      <input
        type="text"
        placeholder="(11) 90000-0000"
        value={form.phone}
        onChange={handleChange('phone')}
        className="modal-form__input"
      />

      <label className="modal-form__label">
        Senha <span className="modal-form__label-required">*</span>
      </label>
      <input
        type="password"
        placeholder="••••••••"
        value={form.password}
        onChange={handleChange('password')}
        className="modal-form__input"
      />

      <button className="modal-form__submit" onClick={handleSubmit}>
        Criar conta
      </button>

      {submitted && (
        <div className="modal-form__success">Conta criada! Bem-vindo à WashPass.</div>
      )}
    </ModalBase>
  );
}
